module.exports = __webpack_public_path__ + "img/21000.e5f2e42a.jpg";